import qs from 'qs';
import { AxiosInstance } from 'axios';
import { OffsetPaginationInput } from '@app/data/inputs';
import { CollectionResource } from '@app/data/resources';
import { CreateWorkspaceUserInput } from './inputs';
import { WorkspaceUserRef } from './refs';
import { WorkspaceUserResource, WorkspaceUserListItemResource } from './resources';

export default class WorkspaceUser {
    private basePath = '/api/workspace-user';
    private http: AxiosInstance;

    constructor(http: AxiosInstance) {
        this.http = http;
    }

    // Get workspace user list
    get = async (pagination: OffsetPaginationInput): Promise<CollectionResource<WorkspaceUserListItemResource, {}>> => {
        const query = qs.stringify(pagination);

        const { data } = await this.http.get(`${this.basePath}/?${query}`);

        return data;
    };

    // Create new workspace user
    create = async (input: CreateWorkspaceUserInput): Promise<WorkspaceUserRef> => {
        const { data } = await this.http.post(`${this.basePath}/`, input);

        return data;
    };

    // Get single workspace user
    getById = async (id: ID): Promise<WorkspaceUserResource> => {
        const { data } = await this.http.get(`${this.basePath}/${id}`);

        return data;
    };
}
